import { getField, updateField } from 'vuex-map-fields';
import { keycloakPlugin } from '@/plugins/keycloak';

const initialState = {
  isAuthenticated: false,
}

const initOptions = {
  onLoad: 'check-sso',
  silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
  responseMode: 'query',
};

export const keycloak = {
  namespaced: true,

  state: initialState,

  actions: {
    initKeycloak({ commit, dispatch }) {
      keycloakPlugin
        .init(initOptions)
        .then(async (authenticated) => {
          commit('setAuthenticated', authenticated);

          if (authenticated || localStorage.getItem('token'))
            await dispatch('auth/getUserInfo', null, { root: true })

          if (!authenticated && !localStorage.getItem('token'))
            commit('auth/setIsAuthen', false, { root: true })
        })
        .catch((err) => {
          console.error('Keycloak initialization failed', err);
        });
    },
    getToken() {
      return keycloakPlugin.token;
    },
    createLoginUrl() {
      return keycloakPlugin.createLoginUrl();
    },
    login() {
      keycloakPlugin.login();
    },
    logout({ commit }) {
      keycloakPlugin.logout();
      commit('resetState');
    },
  },

  getters: {
    getField,
  },

  mutations: {
    updateField,
    setAuthenticated(state, isAuthenticated) {
      state.isAuthenticated = isAuthenticated;
    },
    resetState(state) {
      Object.assign(state, initialState);
    }
  }
};